import { useCallback, useState } from "react";
import { ClaimProvenance } from "./components/ClaimProvenance";
import { EventRail } from "./components/EventRail";
import { NarratorDirectory } from "./components/NarratorDirectory";
import { ResearchLoop } from "./components/ResearchLoop";
import { TopNav } from "./components/TopNav";
import { GraphStage } from "./components/GraphStage";
import { defaultNarrator, events } from "./researchData";
import type { EventRecord, GraphMode, NarratorRecord } from "./types";

function App() {
  const [graphMode, setGraphMode] = useState<GraphMode>("transmission");
  const [selectedNarrator, setSelectedNarrator] = useState<NarratorRecord>(defaultNarrator);
  const [selectedEvent, setSelectedEvent] = useState<EventRecord>(events[0]);
  const selectNarrator = useCallback((person: NarratorRecord) => setSelectedNarrator(person), []);

  return (
    <div className="app-shell">
      <TopNav />
      <main>
        <GraphStage mode={graphMode} onModeChange={setGraphMode} selected={selectedNarrator} onSelect={selectNarrator} />
        <EventRail selected={selectedEvent} onSelect={setSelectedEvent} />
        <ClaimProvenance event={selectedEvent} />
        <NarratorDirectory selected={selectedNarrator} onSelect={(person) => { setSelectedNarrator(person); document.getElementById("graph")?.scrollIntoView({ behavior: "smooth" }); }} />
        <ResearchLoop />
      </main>
      <footer><span>Karbala Epistemic Graph</span><p>Evidence first. Sources visible. Uncertainty preserved.</p><a href="#graph">Return to graph</a></footer>
    </div>
  );
}

export default App;
